// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  text-transform: uppercase;
}
.header ion-icon {
  width: 25px;
  height: 25px;
}
.header .back-icon {
  width: 20px;
  height: 20px;
}

.header-msg {
  font-size: 18px;
  font-family: AppFontMedium, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
}

.payment-method-row {
  align-items: center;
  margin: 6px 12px;
  border-radius: 26px;
  border: 1px solid var(--color-black);
  text-transform: capitalize;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-family: AppFontMedium;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: #faf7f6;
}

.icon-size {
  margin: 0;
  max-width: 120px;
}

.pre-icon-size {
  margin: 0 18px 0 -25px;
  zoom: 0.7;
}

.cash-block {
  display: flex;
  justify-content: center;
}
.cash-block ion-button {
  width: 60%;
  margin: 10px auto;
}

.payment-link {
  width: 100%;
  height: 100%;
  padding: 8px 15px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  background: #f48b7f;
  color: white;
  text-decoration: none;
  text-align: center;
  margin-bottom: 30px;
  border-radius: 28px;
}
.payment-link:hover {
  background: #fc5e07;
}

.bottom-separator {
  padding-top: 10px;
}

#customCard-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
#customCard-container label {
  display: flex;
  align-items: center;
  width: 100%;
}
#customCard-container label iframe {
  height: 50px;
}

/* Загальні стилі для картки */
#customCard-container {
  font-family: "Arial", sans-serif;
  padding: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin: 0 auto;
}
#customCard-container ion-spinner {
  margin: 0 auto;
}

/* Кнопка оплати */
#payButton {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: var(--ion-color-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
#payButton.hidden {
  visibility: hidden;
}

#payButton:hover {
  background-color: #218838;
}

#payButton:active {
  background-color: #1e7e34;
}

/* Стілі для основного контейнера */
.payment-modal-container {
  padding: 20px;
}

.payment-modal-container h2 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.payment-modal-container .payment-method {
  margin-bottom: 20px;
}

.payment-modal-container .total-price {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: right;
}

.iframe-wrapper {
  position: relative;
  display: inline-block;
}

.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */
}

.input_data {
  width: 100%;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  border-bottom: 1px solid var(--color-black);
  border-top: 1px solid var(--color-black);
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #f48b7f;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 14px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-img {
  width: 45px;
}

.info-section {
  background: var(--ion-color-primary);
  padding: 20px;
  display: flex;
  align-items: center;
}
.info-section ion-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.info-section p {
  font-size: 12px;
  color: white;
  text-transform: uppercase;
}

.close-icon {
  margin: 0px;
  width: 25px;
  height: 25px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,YAAA;EACA,YAAA;EACA,WAAA;AAED;;AACA;EACC,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AAED;;AAAA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAGD;AADC;EACC,WAAA;EACA,YAAA;AAGF;AADC;EACC,WAAA;EACA,YAAA;AAGF;;AACA;EACC,eAAA;EACA,sCAAA;EACA,iBAAA;EACA,yBAAA;AAED;;AACA;EACC,mBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,0BAAA;AACD;AAAC;EACC,UAAA;AAEF;AAAE;EACC,gBAAA;EACA,uBAAA;AAEH;AAAG;EACC,iCAAA;EACA,yCAAA;EACA,0BAAA;AAEJ;AACG;EACC,6BAAA;EACA,0BAAA;AACJ;;AAKA;EACC,kBAAA;EACA,WAAA;AAFD;;AAKA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAFD;;AAKA;EACC,YAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,SAAA;EACA,gBAAA;AAFD;;AAIA;EACC,sBAAA;EACA,SAAA;AADD;;AAIA;EACC,aAAA;EACA,uBAAA;AADD;AAGC;EACC,UAAA;EACA,iBAAA;AADF;;AAIA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;AAFD;AAGC;EACC,mBAAA;AADF;;AAKA;EACC,iBAAA;AAFD;;AAIA;EACC,aAAA;EACA,eAAA;EACA,WAAA;AADD;AAEC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AAAF;AACE;EACC,YAAA;AACH;;AAGA,8BAAA;AACA;EACC,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,UAAA;EACA,cAAA;AAAD;AACC;EACC,cAAA;AACF;;AAGA,kBAAA;AACA;EACC,WAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,gBAAA;AAAD;AACC;EACC,kBAAA;AACF;;AAGA;EACC,yBAAA;AAAD;;AAGA;EACC,yBAAA;AAAD;;AAGA,mCAAA;AACA;EACC,aAAA;AAAD;;AAGA;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;AAAD;;AAGA;EACC,mBAAA;AAAD;;AAGA;EACC,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AAAD;;AAEA;EACC,kBAAA;EACA,qBAAA;AACD;;AAEA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA,EAAA,sBAAA;AACD;;AACA;EACC,WAAA;AAED;;AACA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2CAAA;EACA,wCAAA;AAED;AADC;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGF;AADC;EACC,gBAAA;AAGF;AAFE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAIH;AAFE;EACC,0BAAA;EACA,yBAAA;EACA,eAAA;AAIH;AADC;EACC,iBAAA;AAGF;AADC;EACC,WAAA;AAGF;;AAAA;EACC,oCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAGD;AAFC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAIF;AAFC;EACC,eAAA;EACA,YAAA;EACA,yBAAA;AAIF;;AADA;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAID;AAHC;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAKF","sourcesContent":["ion-spinner {\n\tmargin: 32px;\n\theight: 72px;\n\twidth: 72px;\n}\n\n.payment-input {\n\tmargin: 6px 12px;\n\tborder-radius: 5px;\n\tpadding: var(--ion-margin);\n\tcolor: var(--ion-color-black);\n}\n.header {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 20px;\n\ttext-transform: uppercase;\n\n\tion-icon {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t}\n\t.back-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n.header-msg {\n\tfont-size: 18px;\n\tfont-family: AppFontMedium, sans-serif;\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n}\n\n.payment-method-row {\n\talign-items: center;\n\tmargin: 6px 12px;\n\n\tborder-radius: 26px;\n\tborder: 1px solid var(--color-black);\n\ttext-transform: capitalize;\n\t> ion-col {\n\t\tpadding: 0;\n\n\t\tion-item {\n\t\t\toverflow: hidden;\n\t\t\t--background: #00000000;\n\n\t\t\t> ion-radio {\n\t\t\t\t--color: var(--ion-color-primary);\n\t\t\t\t--color-checked: var(--ion-color-primary);\n\t\t\t\tmargin: 11px 16px 10px 4px;\n\t\t\t}\n\n\t\t\t> ion-label {\n\t\t\t\tcolor: var(--ion-color-black);\n\t\t\t\tfont-family: AppFontMedium;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.back-icon {\n\tmargin-right: 10px;\n\twidth: 30px;\n}\n\n.bottom-end {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\theight: 300px;\n\twidth: 142px;\n}\n\n.padding-5 {\n\tpadding: 5px;\n}\n\nion-content {\n\t--background: #faf7f6;\n}\n\n.icon-size {\n\tmargin: 0;\n\tmax-width: 120px;\n}\n.pre-icon-size {\n\tmargin: 0 18px 0 -25px;\n\tzoom: 0.7;\n}\n\n.cash-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\n\tion-button {\n\t\twidth: 60%;\n\t\tmargin: 10px auto;\n\t}\n}\n.payment-link {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 8px 15px;\n\tfont-size: 16px;\n\tfont-family: AppFont, sans-serif;\n\ttext-transform: uppercase;\n\tbackground: #f48b7f;\n\tcolor: white;\n\ttext-decoration: none;\n\ttext-align: center;\n\n\tmargin-bottom: 30px;\n\tborder-radius: 28px;\n\t&:hover {\n\t\tbackground: #fc5e07;\n\t}\n}\n\n.bottom-separator {\n\tpadding-top: 10px;\n}\n#customCard-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\twidth: 100%;\n\tlabel {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\twidth: 100%;\n\t\tiframe {\n\t\t\theight: 50px;\n\t\t}\n\t}\n}\n/* Загальні стилі для картки */\n#customCard-container {\n\tfont-family: 'Arial', sans-serif;\n\tpadding: 20px;\n\tborder: 1px solid #dcdcdc;\n\tborder-radius: 8px;\n\tbackground-color: #fff;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\twidth: 80%;\n\tmargin: 0 auto;\n\tion-spinner {\n\t\tmargin: 0 auto;\n\t}\n}\n\n/* Кнопка оплати */\n#payButton {\n\twidth: 100%;\n\tpadding: 12px;\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tcolor: #fff;\n\tbackground-color: var(--ion-color-primary);\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s ease-in-out;\n\tmargin-top: 10px;\n\t&.hidden {\n\t\tvisibility: hidden;\n\t}\n}\n\n#payButton:hover {\n\tbackground-color: #218838;\n}\n\n#payButton:active {\n\tbackground-color: #1e7e34;\n}\n\n/* Стілі для основного контейнера */\n.payment-modal-container {\n\tpadding: 20px;\n}\n\n.payment-modal-container h2 {\n\ttext-align: center;\n\tcolor: #333;\n\tmargin-bottom: 20px;\n}\n\n.payment-modal-container .payment-method {\n\tmargin-bottom: 20px;\n}\n\n.payment-modal-container .total-price {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tcolor: #333;\n\ttext-align: right;\n}\n.iframe-wrapper {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.iframe-overlay {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpointer-events: none;\n\tbackground-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */\n}\n.input_data {\n\twidth: 100%;\n}\n\n.added-gift {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tpadding: 10px 10px;\n\tborder-bottom: 1px solid var(--color-black);\n\tborder-top: 1px solid var(--color-black);\n\t.header-gift {\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tmin-height: 35px;\n\t\tmin-width: 35px;\n\t\tbackground: #f48b7f;\n\t\tborder: 1px solid var(--color-black);\n\t\tborder-radius: 50%;\n\t\tfont-size: 10px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t}\n\t.inner-text-gift {\n\t\tmargin-left: 5px;\n\t\th3 {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 14px;\n\t\t}\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n\t.delete-items-section {\n\t\tmargin-left: auto;\n\t}\n\tion-img {\n\t\twidth: 45px;\n\t}\n}\n.info-section {\n\tbackground: var(--ion-color-primary);\n\tpadding: 20px;\n\tdisplay: flex;\n\talign-items: center;\n\tion-icon {\n\t\twidth: 45px;\n\t\theight: 45px;\n\t\tmargin-right: 10px;\n\t}\n\tp {\n\t\tfont-size: 12px;\n\t\tcolor: white;\n\t\ttext-transform: uppercase;\n\t}\n}\n.close-icon {\n\tmargin: 0px;\n\twidth: 25px;\n\theight: 25px;\n\tpadding: 0px;\n\tz-index: 99;\n\tion-icon {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmargin: 0px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
